import type { ReactNode } from "react";

// Eine beschriftete Angabe einer Ausschreibung (Frist, Kategorien, Zustand der eigenen Bewerbung), in
// der Verwaltung wie auf der Bewerber-Seite gleich gesetzt.
export function ListingField({ label, children }: { label: ReactNode; children: ReactNode }) {
  return (
    <div className="min-w-0">
      <div className="smycles-field-label">{label}</div>
      <div className="smycles-field-value mt-0.5">{children}</div>
    </div>
  );
}
